var React = require('react');

function CheveronDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.410696 0.761388C0.582372 0.575567 0.817285 0.433446 1.05285 0.433446C1.26552 0.433446 1.47813 0.510305 1.64642 0.665746L12.4192 10.5641L23.1919 0.665746C23.5472 0.337789 24.1014 0.358282 24.4277 0.715276C24.7556 1.07055 24.7335 1.62203 24.379 1.94999L13.0105 12.4441C12.6741 12.755 12.1601 12.755 11.8234 12.4441L0.45488 1.94999C0.104949 1.66869 0.0827587 1.11669 0.410696 0.761388Z","fill":"currentColor"}));
}

CheveronDownIcon.defaultProps = {"width":"25","height":"13","viewBox":"0 0 25 13","fill":"none"};

module.exports = CheveronDownIcon;

CheveronDownIcon.default = CheveronDownIcon;
